import { BaseApi, PassVersionMode } from '../base-api';

import type { DeveloperProfile } from './interfaces';

export class DevelopersApi extends BaseApi {
  protected readonly passVersionMode = PassVersionMode.None;
  protected readonly prefix: string = 'developers';

  fetchDeveloperProfile = (ownerId: string) => this.get<DeveloperProfile>(`${ownerId}/profile`);
}
